const handleShareButton = () => {

    const sharePostButtons = document.querySelectorAll( '.share-post' );

    if ( sharePostButtons.length > 0 ) {
        copyLink();
        moveShareButton();
    }
}

// Copy link to current post on icon click
const copyLink = () => {

    const copyLinkButtons = document.querySelectorAll( '.share-post .share-icons button');

    for ( const button of copyLinkButtons ) {
        button.addEventListener( 'click', () => {
            navigator.clipboard.writeText( window.location.href );
        } )
    }
}

// Show share icons on button click
const moveShareButton = () => {

    const shareButtons = document.querySelectorAll( '.share-post .share-button' );

    for ( const shareButton of shareButtons ) {
        const button = shareButton.querySelector( 'button' );

        button.addEventListener( 'click', () => {
            shareButton.classList.toggle( 'opened' );
        } )
    }

}

document.addEventListener( 'DOMContentLoaded', () => {
    handleShareButton();
} );
